import styled from 'styled-components';
import Spinner from '../Global/Atomics/Spinner';
import { WidgetCard } from '../Global/Atomics/WidgetCard';
import { AreaChartComponent } from '../Global/Charts/AreaChartComponent';
import CustomIcon from '../Global/Icons/CustomIcon';
import { Text } from '../Global/Atomics/Text';
import HorizontalBar from '../Global/Charts/HorizontalBars';
import Theme from '../../styles/Theme/Theme';
import { useState } from 'react';
import { useEffect } from 'react';

export const StreetBarChartWidget = (props) => {
    const [data, setData] = useState(props);

    useEffect(()=> {
        if(props){
            setData(props);
        }
    }, [props]);
    
    return (
        <WidgetCard display='flex' flexDirection='column' padding={Theme.spacing.videowall.md} margin={Theme.spacing.videowall.xxs} justifyContent='space-between'>
            {data?.block !== null ?
            <>
                <div style={{ display: "flex", alignItems: 'flex-end'}}><CustomIcon icon={data?.block?.icon ?? 'Bolt'} iconSize='md' color="#008000" strokeWidth='1'/><Text marginLeft='0.4vw'  fontSize='text_lg' color='black'>{data?.block?.title}</Text></div>
                <div style={{ display: 'flex', height: '90%'}}>
                    <HorizontalBar data={data?.block} />
                </div>
            </>
            : <div style={{height: 'inherit', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}><Spinner stroke="green"/></div>}
        </WidgetCard>
    );
};